






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  data() {
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "name",
          "sort-desc": false,
        },
        content: {
          name: "Charging Point Operators",
          urlEnabled: true,
          topActionButtons: {
            insert: false,
          },
          displayFields: {
            name: {
              text: "Organization",
              sortable: true,
            },
            enableRoaming: {
              text: "Roaming",
              options: {
                boolean: true,
                label: (value, item) => {
                  return item?.ocpiServerCredentialsRole?.party_id ? "Enabled" : "Disabled";
                },
                attrs(value, item) {
                  return {
                    color: item?.ocpiServerCredentialsRole?.party_id ? "green" : "red",
                  };
                },
              },
            },
            countryCode: {
              text: "Country Code",
              options: {
                transform: (value, item) => {
                console.log(item.name);
                console.log(item.ocpiServerCredentialsRole);
                  return item?.ocpiServerCredentialsRole?.country_code;
                },
              },
            },
            partyId: {
              text: "Party ID",
              options: {
                transform: (value, item) => {
                  return item?.ocpiServerCredentialsRole?.party_id;
                },
              },
            },
            action: {
              text: "Actions",
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: false,
            },
          },
        },
        ext: {
          dataProvider: {
            async findAll() {
              const { items, count } = await coreApiClient.call(
                "ocpiServerCredentialsRoles",
                "findAllCPO",
              );
              return [items, count];
            },
            async update(item) {
              console.log("update item", item);
              return await coreApiClient.call(
                "ocpiServerCredentialsRoles",
                "updateOrCreateCPORole",
                {},
                {
                  data: {
                    tenantId: item.tenantId,
                    business_details: { name: item.name },
                    country_code: item.countryCode,
                    party_id: item.partyId,
                    status: item.status,
                  },
                }
              );
            },
          },
          default: {
            defaultInputs: {
              status: {
                type: "boolean",
                attrs: {
                  label: "Enabled",
                },
                ext: {
                  defaultValue: false,
                },
              },
              "ocpiServerCredentialsRole.business_details.name": {
                attrs: {
                  label: "Name",
                  required: true,
                },
              },
              "ocpiServerCredentialsRole.country_code": {
                attrs: {
                  label: "Country Code"
                },
              },
              "ocpiServerCredentialsRole.party_id": {
                attrs: {
                  label: "Party ID"
                },
              },
            },
            editForm: userManager.checkRole(["systemAdmin"]) && {
              content: {
                fieldNames: ["ocpiServerCredentialsRole.business_details.name", "status", "ocpiServerCredentialsRole.country_code", "ocpiServerCredentialsRole.party_id"],
              },
            },
          },
        },
      },
    };
  },
});
